import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import detractionBasicInformationPropTypes from '../proptypes/TransactionPropTypes';
import { numberFormatter } from '../../../../../utils/number';
import { SALES_SESSION_PATH } from '../../../../../config/paths';

const TransactionBasicInformationResource = ({
  id,
  amount,
  user,
  customer,
  paymentMethod,
  transactionType,
  salesSessionId,
  expenseId,
  expenseType,
  generalIncomeId,
  generalIncomeType,
  customerOrderId,
  voucherType
}) =>
  expenseId || generalIncomeId ? (
    <>
      <ResourceProperty label="Nombres:">
        {user.customer.firstName}
      </ResourceProperty>
      <ResourceProperty label="Apellidos:">
        {user.customer.lastName}
      </ResourceProperty>
      <ResourceProperty label="ID:">{user.id}</ResourceProperty>
      <ResourceProperty label="Monto:">{numberFormatter({ value: amount, style: 'currency'})}</ResourceProperty>
      <ResourceProperty label="Cliente:">
        {`${customer.firstName} ${customer.lastName}`}
      </ResourceProperty>
      <ResourceProperty label="Método de Pago:">
        {paymentMethod.name}
      </ResourceProperty>
      <ResourceProperty label="Tipo de Transacción:">
        {transactionType.transactionType}
      </ResourceProperty>
      <ResourceProperty label="Sesión de Ventas:">
        <a href={`${SALES_SESSION_PATH}/${
          salesSessionId
        }`}>{salesSessionId}</a>
      </ResourceProperty>
      {expenseId ? (
        <>
          <ResourceProperty label="Egreso:">{expenseId}</ResourceProperty>
          <ResourceProperty label="Tipo de Egreso:">
            {expenseType.name}
          </ResourceProperty>
        </>
      ) : (
        <>
          <ResourceProperty label="Ingreso:">
            {generalIncomeId}
          </ResourceProperty>
          <ResourceProperty label="Tipo de Ingreso:">
            {generalIncomeType.name}
          </ResourceProperty>
        </>
      )}
    </>
  ) : (
    <>
      <ResourceProperty label="Nombres:">
        {user.customer.firstName}
      </ResourceProperty>
      <ResourceProperty label="Apellidos:">
        {user.customer.lastName}
      </ResourceProperty>
      <ResourceProperty label="ID:">{id}</ResourceProperty>
      <ResourceProperty label="Monto:">
        {numberFormatter({ value: amount, style: 'currency'})}
        </ResourceProperty>
      <ResourceProperty label="Orden:">{customerOrderId}</ResourceProperty>
      <ResourceProperty label="Cliente:">
        {`${customer.firstName} ${customer.lastName}`}
      </ResourceProperty>
      <ResourceProperty label="Método de Pago:">
        {paymentMethod.name}
      </ResourceProperty>
      <ResourceProperty label="Tipo de Comprobante:">
        {voucherType.name}
      </ResourceProperty>
      <ResourceProperty label="Código:">
        {transactionType.id}
      </ResourceProperty>
      <ResourceProperty label="Tipo de Transacción:">
        {transactionType.transactionType}
      </ResourceProperty>
      <ResourceProperty label="Sesión de Ventas:">
        <a href={`${SALES_SESSION_PATH}/${
          salesSessionId
        }`}>{salesSessionId}</a>
      </ResourceProperty>
    </>
  );

TransactionBasicInformationResource.propTypes =
  detractionBasicInformationPropTypes;

export default TransactionBasicInformationResource;
